<template>
  <div class="market-page ">
    <div class="title" >{{ $t('fmall-ex-jin-ri-hang-qing') }}</div>
    <div class="sub-title">{{ $t('cha-kan-shu-bai-zhong') }}</div>
    <div class="rankList ">
      <div class="table-th flex-center">
        <div class="th flex-3">{{ $t('transfer.label3') }}</div>
        <div class="th flex-2 text-center">{{ $t('index.label10') }}</div>
        <div class="th flex-2 text-center">{{ $t('zhang-die-fu') }}</div>
        <div class="th flex-3 text-center">{{ $t('qu-shi-tu') }}</div>
        <div class="th action text-center">{{ $t('cao-zuo-1') }}</div>
      </div>
      <bit-page :dataList="marketList" @detail="toDetail" :pageSpace="page.page * page.limit"></bit-page>

      <pageBar :total="page.total" @changePage="changePage"></pageBar>
    </div>
  </div>
</template>

<script>
import { getCoinList, quoteList } from '@/api/index'
import { Button, Search, List, Field } from 'vant';
import bitPage from '@/components/bit'
import { initWebSocket } from '@/utils/common'
import pageBar from '@/components/pageBar'
export default {
  name: 'about',
  components: {
    Button,
    Search,
    List,
    Field,
    bitPage,
    pageBar
  },
  data() {
    return {
      form: {
        keyword: ''
      },
      isInit: false,
      loading: false,
      page: {
        page: 1,
        limit: 10,
        total: 1
      },
      totalPage: 1,
      marketList: [],
      bitListBak: [],
      searchListBack: [],
      isSearch: false,
      webSocket: null,
      // quoteListBak: []
    }
  },
  computed: {
    isSend() {
      return this.$store.state.isSend
    },
    bitList() {
      return this.$store.state.bitList
    }
  },
  beforeDestroy() {
    this.$store.state.isSend = false
    if (this.webSocket && this.webSocket.close) {
      this.$store.state.isClose = true
      this.webSocket.close()
    }
  },
  mounted() {
    // this.initHistory()
    this.initCoin()
    this.initSocket()
  },
  methods: {
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    initCoin() {
      //币种列表
      let list = localStorage.getItem('bitList')
      if (list && list != 'undefined' && this.bitList.length == 0) {
        this.$store.state.bitList = JSON.parse(list)
      } 
      if (this.bitList.length > 0) {
        this.marketList = [].concat(this.bitList).filter(v => {
          return v.Show == 1
        }).slice(0, this.page.limit)
        this.bitListBak = [].concat(this.bitList)
        this.isInit = true
        this.loading = false
      }
      this.init()
    },
    init() {
      this.loading = true
      getCoinList({
        current: this.page.page,
        pageSize: this.page.limit,
        Status: 1,
      }).then(res => {
        if (res.data.Items) {
          this.totalPage = res.data.Pagination.totalPage
          this.page.total = res.data.Pagination.totalRecords
         
          let newList = res.data.Items.map(v => {
            v.percent = 0
            return v
          })
          this.bitListBak = newList
          this.marketList = [].concat(this.bitListBak)
          // .filter(v => {
          //   return v.Show == 1
          // })
         
        }
        this.isInit = true
        this.loading = false
        this.$store.state.bitList = [].concat(this.bitListBak)
        localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
      })
    },
    onLoad() {
      this.page.page += 1
      this.init(true)
    },
    searchMarket() {
      if (!this.form.keyword) {
        if (this.isSearch) {
          this.clearSearch()
        }
        return
      }
      this.isSearch = true
      this.marketList = this.bitListBak.filter(v => {
        return v.Name.toLowerCase().indexOf(this.form.keyword) > -1 && v.Show == 1
      })
    },
    clearSearch() {
      this.isSearch = false
      this.marketList = [].concat(this.bitListBak).filter(v => {
        return v.Show == 1
      })
    },
    async initSocket(){ //初始化weosocket
      let client = await initWebSocket('all', this.websocketonmessage)
      this.webSocket = client.ws
    },
    websocketonmessage(e){ //数据接收
      let redata = {}
      try {
        redata = JSON.parse(e.data)
        this.setListData(redata)
      }
      catch(e) {
      }
    },   
    setListData(data) {
      let index = this.bitListBak.findIndex(v => {
        return v.ShortName + '-USDT' == data.tags.InstId
      })
      let valObj = data.fields
      let percent = parseFloat(((valObj.Close - valObj.Yesterday) / valObj.Yesterday * 100).toFixed(2))
      if (index > -1) {
        this.bitListBak[index] = {
          ...this.bitListBak[index],
          ...valObj,
          percent,
          count: valObj.Close,
        }
      }
      if (this.form.keyword) {
        this.marketList = this.bitListBak.filter(v => {
          return v.ShortName.toLowerCase().indexOf(this.form.keyword) > -1 && v.Show == 1
        })
      } else {
        this.marketList = [].concat(this.bitListBak).filter(v => {
          return v.Show == 1
        })
      }
      this.$store.state.bitList = [].concat(this.bitListBak)
      localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
    },
    toDetail(data) {
      this.$router.push({
        name: 'trade',
        query: {
          name: data.ShortName,
          id: data.ID,
          type: 2
        }
      })
    },
    changePage(page) {
      this.page.page = page
      this.init()
    }
  },
}
</script>
<style lang="less">

</style>
